import {
  CreditCardIcon,
  LogoutIcon,
  PersonIcon,
  TuneIcon,
} from 'components/icons'
import { useCurrentUser } from 'context/current-user-context'
import { Menu } from 'ui'

const CurrentUserMenu = () => {
  const { uuid, logout, isAdmin, isPromo } = useCurrentUser()

  return (
    <>
      <Menu.Item
        label="My Profile"
        href={`/users/${uuid}`}
        IconComponent={PersonIcon}
      />
      <Menu.Item
        label="My Preferences"
        href={`/users/${uuid}/preferences`}
        IconComponent={TuneIcon}
      />
      {isAdmin && !isPromo && (
        <Menu.Item
          label="Billing"
          href={`/billing`}
          IconComponent={CreditCardIcon}
        />
      )}
      <Menu.Divider />
      <Menu.Item
        context="negative"
        label="Log Out"
        onClick={logout}
        IconComponent={LogoutIcon}
      />
    </>
  )
}

export default CurrentUserMenu
